const CONTACT_TYPE = {
  CHILD: 1,
  MOTHER: 2,
  FATHER: 3,
  STAFF: 4
}

export default CONTACT_TYPE
